var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAptos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_246545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4013_246545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4013_246545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7602 21.7602H-0.760201V-0.760193H21.7602V21.7602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4013_246545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7858 10.5C20.7858 16.1826 16.1826 20.7858 10.5 20.7858C4.8174 20.7858 0.214199 16.1826 0.214199 10.5C0.214199 4.8174 4.8174 0.214203 10.5 0.214203C16.1826 0.214203 20.7858 4.8174 20.7858 10.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4013_246545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4013_246545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.209999V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4013_246545)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "matrix(1 0 0 -1 0 21)",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5216 8.69656H12.548C12.4345 8.69656 12.3266 8.64787 12.2515 8.56314L11.8565 8.11694C11.7977 8.05034 11.713 8.01245 11.6243 8.01245C11.5357 8.01245 11.451 8.05057 11.3922 8.11694L11.0534 8.49975C10.9425 8.62491 10.7834 8.69679 10.6162 8.69679H5.28641C5.13462 9.12944 5.03564 9.58642 4.99615 10.0604H10.0276C10.116 10.0604 10.2008 10.0244 10.2619 9.96051L10.7303 9.4716C10.7889 9.41052 10.8697 9.37607 10.9542 9.37607H10.9735C11.0624 9.37607 11.1469 9.41419 11.2057 9.48079L11.6004 9.92699C11.6755 10.012 11.7835 10.0604 11.8969 10.0604H16.0039C15.9644 9.5862 15.8654 9.12921 15.7136 8.69679H13.5214L13.5216 8.69656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04075 12.9279C8.12917 12.9279 8.2139 12.8919 8.27499 12.8281L8.74346 12.3391C8.80202 12.2781 8.88285 12.2436 8.96736 12.2436H8.98665C9.07552 12.2436 9.16003 12.2817 9.21882 12.3481L9.61358 12.7943C9.68867 12.8793 9.7966 12.9277 9.91005 12.9277H15.4757C15.6842 12.4969 15.8369 12.0346 15.9278 11.5503H10.5857C10.4722 11.5503 10.3643 11.5016 10.2892 11.4169L9.89443 10.9707C9.83564 10.9041 9.75091 10.8662 9.66226 10.8662C9.57362 10.8662 9.48888 10.9043 9.43009 10.9707L9.09137 11.3535C8.98045 11.4787 8.82131 11.5505 8.6539 11.5505H5.07193C5.16287 12.0349 5.31581 12.4971 5.5241 12.9279H8.04075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9892 7.20641C12.0777 7.20641 12.1624 7.17036 12.2235 7.10652L12.6919 6.61761C12.7505 6.55652 12.8313 6.52207 12.9158 6.52207H12.9351C13.024 6.52207 13.1085 6.56019 13.1673 6.62679L13.5621 7.07299C13.6372 7.15796 13.7451 7.20641 13.8585 7.20641H14.917C13.9091 5.86667 12.3059 5 10.5 5C8.69409 5 7.09095 5.86667 6.08305 7.20641H11.9892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86343 14.293H8.41599C8.30255 14.293 8.19461 14.2443 8.11952 14.1595L7.72476 13.7133C7.66598 13.6467 7.58124 13.6089 7.49259 13.6089C7.40395 13.6089 7.31921 13.647 7.26043 13.7133L6.9217 14.0962C6.81078 14.2213 6.65164 14.2932 6.48423 14.2932H6.46173C7.47009 15.3737 8.90605 16.05 10.5005 16.05C12.0949 16.05 13.5306 15.3737 14.5392 14.2932H9.86343V14.293Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_246545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAptos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aptos.995b328ac5b8497cae9ae4603dbb6c6e.svg";